import { render, staticRenderFns } from "./AttachDocs.vue?vue&type=template&id=eb1dd6b8&scoped=true&"
import script from "./AttachDocs.vue?vue&type=script&lang=js&"
export * from "./AttachDocs.vue?vue&type=script&lang=js&"
import style0 from "./AttachDocs.vue?vue&type=style&index=0&id=eb1dd6b8&lang=scss&scoped=true&"
import style1 from "./AttachDocs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1dd6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb1dd6b8')) {
      api.createRecord('eb1dd6b8', component.options)
    } else {
      api.reload('eb1dd6b8', component.options)
    }
    module.hot.accept("./AttachDocs.vue?vue&type=template&id=eb1dd6b8&scoped=true&", function () {
      api.rerender('eb1dd6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/AttachDocs.vue"
export default component.exports